<template>
  <div class="addtocart">
    <modal full-header @close="closeModal" :hide-footer="true" :width="widthStyle">
      <template slot="body">
        <div class="container">
          <div class="row">
            <div :class="divGrid" style="padding:0" :style="toggleRollInto ? 'opacity:0.2' : ''">
              <div ref="headerImg" :style="getImageStyle" class="modalImage w-100" />
              <img
                v-show="false"
                :src="getProductImage(product)"
                @error="imgHttpError"
                alt="productImage"
              />
              
              <div class="numbers-container">
                <div v-if="!isDigitalDisplay" class="w-100 pb-1 my-2 d-flex">
                  <button
                    :style="desktopStyles.CommonColorTxt"
                    :disabled="quantity <= 1"
                    class="btn-white btn-circle d-flex justify-content-center align-items-center"
                    @click="dec"
                  >
                    <span class="material-icons bigger-material-icons">remove_circle_outline</span>
                  </button>
                  <span class="d-flex align-items-center">
                    <strong>{{ quantity }}</strong>
                  </span>
                  <button
                    :style="desktopStyles.CommonColorTxt"
                    class="btn-white btn-circle d-flex justify-content-center align-items-center"
                    @click="inc"
                  >
                    <span class="material-icons bigger-material-icons">add_circle_outline</span>
                  </button>
                </div>
                <div class="w-100 d-flex mb-2" style="font-size: 1.17em;">
                  <h3 v-if="price > 0">{{ price | formatMoney(currencySign) }}</h3>
                  <h3
                    v-if="getPoints"
                    class="ml-2 text-success"
                  >({{ getPoints | formatNumber }} pts)</h3>
                </div>
              </div>

              <div class="px-3 pt-3 item-description-container ios-scroll">
                <div
                  class="container-fluid pitem-details"
                  style="max-height:255px; padding:0.3rem 0.0rem 0.3rem 0.3rem;"
                >
                  <h3 class="pt-2">{{ category.Name }}</h3>
                  <p v-html="product.ShortDescription"></p>

                  <div v-if="showRollIntoProduct" class="container mb-2">
                    <div class="row">
                      <a
                        v-if="selectedRollIntoModiefiers.length == 0"
                        :style="desktopStyles.roolIntoButton"
                        @click="
                          toggleRollInto = true;
                          $forceUpdate();
                        "
                      >
                        <div class="roll-into-items">
                          <div class="roll-item-details text-left">
                            <div class="roll-item-details-name">{{ showRollIntoProduct.Name }}</div>
                          </div>
                          <div
                            v-if="getRollIntoPoints"
                            class="roll-item-point"
                          >({{ getRollIntoPoints | formatNumber }} pts)</div>
                          <div class="roll-item-cost" :class="getRollIntoPoints ? 'has-point' : ''">
                            {{
                            showRollIntoProduct.FixedPriceValue | formatMoney(currencySign)
                            }}
                          </div>
                        </div>
                      </a>
                      <a v-else class="w-100" @click="toggleRollInto = true">
                        <div
                          v-if="selectedRollIntoModiefiers.length > 0"
                          :style="desktopStyles.roolIntoButton"
                          class="h-100"
                        >
                          <div class="col-sm-12 roll-into-items">
                            <div class="roll-item-details text-left">
                              <div class="roll-item-details-name">{{ showRollIntoProduct.Name }}</div>
                              <ul>
                                <li
                                  v-for="md in selectedRollIntoModiefiers"
                                  :key="md.ID"
                                  :style="desktopStyles.primaryColor"
                                >{{ md.Name }} ({{ md.quantity }})</li>
                              </ul>
                            </div>
                            <div
                              v-if="getRollIntoPoints"
                              class="roll-item-point"
                            >({{ getRollIntoPoints | formatNumber }} pts)</div>
                            <div
                              class="roll-item-cost"
                              :class="getRollIntoPoints ? 'has-point' : ''"
                            >{{ rollIntoPrice | formatMoney(currencySign) }}</div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div class="w-100 mb-2" v-show="viewConfig.ShowNotesForItem">
                    <div>
                      <h4>{{ $t("message.notes") }}</h4>
                      <textarea
                        id="notes"
                        maxlength="300"
                        v-model="itemNote"
                        name="notes"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="padding:20px 20px 0 20px; bottom:0"
                class="flex-wrap justify-content-center sticky"
                v-if="
                  !(!isEmptyModifier || (toggleRollInto && showRollIntoProduct))
                "
              >
                <div class="w-100 d-flex justify-content-between sticky">
                  <button
                    type="button"
                    class="btn btn-lg btn-cancel"
                    data-dismiss="modal"
                    :disabled="toggleRollInto"
                  >{{ $t("message.cancel") }}</button>
                  <button
                    type="button"
                    data-dismiss="modal"
                    v-if="!isDigitalDisplay"
                    :disabled="isDisabledAddCards"
                    :style="desktopStyles.btn"
                    class="btn btn-lg btn-primary w-75 d-flex justify-content-between shadow"
                    @click="addToCart()"
                  >
                    <span>{{ $t("message.addToCart") }}</span>
                    <span>
                      {{ totalPrice | formatMoney(currencySign)
                      }}{{
                      getPoints
                      ? " (" +
                      Intl.NumberFormat().format(getPoints) +
                      " pts)"
                      : ""
                      }}
                    </span>
                    <!-- <span v-else>{{ $t("message.maximumQuantityExceeded") }}</span> -->
                  </button>
                </div>
              </div>
            </div>
            <div
              style="position: relative;"
              class="col-sm-7"
              v-if="!isEmptyModifier || (toggleRollInto && showRollIntoProduct)"
            >
              <div class="row">
                <div class="col-md-8 combo-groups pr-0 z-index-999">
                  <div class="modifier-container" v-show="!toggleRollInto">
                    <Modifiers
                      @showSubmodifier="customizeSubmodifier"
                      :product="product"
                      :modifiers="modifiers"
                      :modifier-groups-states="ModifierGroupsStates"
                      :initial-modifiers="initialMainModifiers"
                      :is-submodifier="toggleRollInto"
                      ref="modifiersRefs"
                    />
                  </div>

                  <div
                    class="modifier-container"
                    v-if="toggleRollInto && !selectedModifierForCustomize"
                  >
                    <Modifiers
                      ref="rollIntoRef"
                      v-if="toggleRollInto"
                      :price-trigger="showRollIntoProduct"
                      @canceled="toggleRollInto = false"
                      :product="rollIntoParams.product"
                      :modifiers="rollIntoParams.modifiers"
                      :product-id="rollIntoParams.productId"
                      @updated="selectRollIntoModiefiers"
                      :is-submodifier="toggleRollInto"
                      :initial-modifiers="rollIntoParams.initModifiers"
                      :modifier-groups-states="RollIntoModifierGroupsStates"
                    />
                  </div>

                  <div
                    class="modifier-container"
                    v-show="toggleRollInto && selectedModifierForCustomize"
                  >
                    <Modifiers
                      ref="subModifierRef"
                      v-if="toggleRollInto"
                      @canceled="cancelSubmodifiers()"
                      :product="rollIntoParams.product"
                      :modifiers="rollIntoParams.modifiers"
                      :product-id="rollIntoParams.productId"
                      :is-submodifier="toggleRollInto"
                      :initial-modifiers="rollIntoParams.initModifiers"
                      :modifier-groups-states="SubModifierGroupsStates"
                    />
                  </div>

                  <div class="sticky z-index-999">
                    <div
                      class="btn-add-combo-container justify-content-between"
                      v-show="!toggleRollInto"
                    >
                      <button
                        type="button"
                        class="btn btn-lg btn-cancel"
                        data-dismiss="modal"
                        :disabled="toggleRollInto"
                      >{{ $t("message.cancel") }}</button>
                      <button
                        type="button"
                        :disabled="isDisabledAddCards"
                        :style="desktopStyles.btn"
                        :data-dismiss="getModifierValidation(false)? 'modal': ''"
                        v-if="!isDigitalDisplay"
                        class="btn btn-lg btn-primary w-75 d-flex justify-content-between shadow"
                        @click="addToCart()"
                      >
                        <span>{{ $t("message.addToCart") }}</span>
                        <span>
                          {{ totalPrice | formatMoney(currencySign)
                          }}{{
                          getPoints
                          ? " (" +
                          Intl.NumberFormat().format(getPoints) +
                          " pts)"
                          : ""
                          }}
                        </span>
                        <!-- <span v-else>{{ $t("message.maximumQuantityExceeded") }}</span> -->
                      </button>
                    </div>
                    <div
                      class="btn-add-combo-container justify-content-between sticky"
                      v-show="toggleRollInto"
                    >
                      <button
                        type="button"
                        class="btn btn-lg btn-cancel"
                        @click="cancelRollInto()"
                      >{{ $t("message.cancel") }}</button>
                      <button
                        v-if="!selectedModifierForCustomize"
                        type="button"
                        :style="desktopStyles.btn"
                        class="btn btn-lg btn-primary w-75 d-flex justify-content-between shadow"
                        @click="addRollInto()"
                      >
                        <span
                          style="width: 75%;overflow: hidden;text-align: left;"
                          v-if="toggleRollInto && showRollIntoProduct"
                        >
                          {{
                          showRollIntoProduct.Name
                          }}
                        </span>
                        <span v-if="toggleRollInto">
                          {{
                          rollIntoInnerPrice | formatMoney(currencySign)
                          }}
                        </span>
                      </button>
                      <button
                        v-if="selectedModifierForCustomize"
                        type="button"
                        :style="desktopStyles.btn"
                        class="btn btn-lg btn-primary w-75 d-flex justify-content-between shadow"
                        @click="addSubmodifiers()"
                      >
                        <span
                          style="width: 75%;overflow: hidden;text-align: left;"
                        >{{ selectedModifierForCustomize.Name }}</span>
                        <span>{{ submodifiersPrice | formatMoney(currencySign) }}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="item-summary">
                    <div class="item-summary-details">
                      <h4>{{ $t("message.itemSummary") }}</h4>
                      <ul>
                        <li
                          v-for="mgs in sortedModifierGroupsStates.filter(
                            p => p.quantity > 0
                          )"
                          :key="mgs.MID"
                        >
                          <div class="d-flex">
                            <div class="item-summary-name">
                              {{
                              modifiers[mgs.GroupId].Modifiers.find(
                              p => p.ID == mgs.MID
                              ).Name
                              }}({{ mgs.quantity }})
                            </div>
                            <div class="item-summary-price">
                              {{
                              modifiers[mgs.GroupId].Modifiers.find(
                              p => p.ID == mgs.MID
                              ).Price | formatMoney(currencySign)
                              }}
                            </div>
                          </div>
                          <ul
                            v-if="
                              modifiers[mgs.GroupId].Modifiers.find(
                                p => p.ID == mgs.MID
                              ).selectedSubmodifiers &&
                                modifiers[mgs.GroupId].Modifiers.find(
                                  p => p.ID == mgs.MID
                                ).selectedSubmodifiers.length > 0
                            "
                          >
                            <li
                              v-for="sub in modifiers[
                                mgs.GroupId
                              ].Modifiers.find(p => p.ID == mgs.MID)
                                .selectedSubmodifiers"
                              :key="sub.ID"
                            >
                              <div class="d-flex">
                                <div class="item-summary-name">{{ sub.Name }}({{ sub.quantity }})</div>
                                <div
                                  class="item-summary-price"
                                >{{ (sub.Price * sub.quantity) | formatMoney(currencySign) }}</div>
                              </div>
                            </li>
                            <li class="d-flex">
                              <div class="item-summary-name"></div>
                              <div
                                class="item-summary-price font-weight-bold"
                                style="font-size:1rem;"
                              >
                                {{
                                computePrice(
                                modifiers[mgs.GroupId].Modifiers.find(
                                p => p.ID == mgs.MID
                                )
                                ) | formatMoney(currencySign)
                                }}
                              </div>
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <hr
                        v-if="
                          ModifierGroupsStates.filter(p => p.quantity > 0)
                            .length > 0 &&
                            RollIntoModifierGroupsStates.filter(
                              p => p.quantity > 0
                            ).length > 0
                        "
                      />
                      <ul>
                        <li
                          v-for="rm in RollIntoModifierGroupsStates.filter(
                            p => p.quantity > 0
                          )"
                          :key="rm.MID"
                        >
                          <div class="d-flex">
                            <div class="item-summary-name">
                              {{
                              modifiers[rm.GroupId].Modifiers.find(
                              p => p.ID == rm.MID
                              ).Name
                              }}({{ rm.quantity }})
                            </div>
                            <div class="item-summary-price">
                              {{
                              modifiers[rm.GroupId].Modifiers.find(
                              p => p.ID == rm.MID
                              ).Price | formatMoney(currencySign)
                              }}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import modal from "./../../modal.vue";
import Modifiers from "./Modifiers";
import shared from "../../../sharedscripts/shop/products/AddToCart.js";
export default {
  name: "AddToCart",
  components: { modal, Modifiers },
  props: {
    category: {
      type: Object,
      default: () => {}
    },
    parentCategory: {
      type: Object,
      default: () => {}
    },
    product: {
      type: Object,
      default: () => {}
    },
    modifiers: {
      type: Object,
      default: () => {}
    },
    price: {
      type: Number,
      default: 0
    },
    productId: {
      type: Number,
      default: 0
    },
    imageStyles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      quantity: 1,
      // maxItemQuantity: 20,
      selectedModifiers: [],
      ModifierGroupsStates: [],
      toggleRollInto: false,
      selectedRollIntoModiefiers: [],
      itemNote: "",
      selectedModifierForCustomize: null,
      RollIntoModifierGroupsStates: [],
      SubModifierGroupsStates: [],
      forceUpdate: false
    };
  },
  computed: {
    ...shared.computed,
    ...mapGetters([
      "viewConfig",
      "desktopStyles",
      "canshowRollInto",
      "storeMenu",
      "isDigitalDisplay"
    ]),
    divGrid() {
      return this.isShowSecondCol &&
        (!this.isEmptyModifier ||
          (this.toggleRollInto && this.showRollIntoProduct))
        ? "col-sm-5"
        : "col-sm-12";
    },
    divDetailsGrid() {
      return this.isShowSecondCol &&
        (!this.isEmptyModifier ||
          (this.toggleRollInto && this.showRollIntoProduct))
        ? "col-sm-7"
        : "col-sm-12";
    },
    widthStyle() {
      return this.isShowSecondCol &&
        (!this.isEmptyModifier ||
          (this.toggleRollInto && this.showRollIntoProduct))
        ? "1000px"
        : "500px";
    },
    isShowSecondCol() {
      if (
        (this.product.ModifierGroups &&
          this.product.ModifierGroups.length > 0) ||
        this.showRollIntoProduct
      )
        return true;
      else return false;
    },
    divScroll() {
      if (!this.toggleRollInto) return [{ "overflow-y": "scroll" }];
      return [];
    },
    showRollIntoProduct() {
      return this.canshowRollInto(
        { ...this.product, quantity: this.quantity },
        this.quantity
      );
    },
    isEmptyModifier() {
      let res = true;
      if (this.product.ModifierGroups) {
        for (let elem of this.product.ModifierGroups) {
          if (
            this.modifiers[elem] &&
            this.modifiers[elem].Modifiers.length > 0
          ) {
            res = false;
            break;
          }
        }
      }
      return res;
    },
    menuCopy() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    rollIntoParams() {
      if (this.selectedModifierForCustomize)
        return {
          product: this.menuCopy.Products[
            this.selectedModifierForCustomize.LinkedProductID
          ],
          modifiers: this.menuCopy.ModifierGroups,
          productId: this.selectedModifierForCustomize.LinkedProductID,
          initModifiers: this.selectedModifierForCustomize.selectedSubmodifiers
        };
      else if (this.showRollIntoProduct)
        return {
          product: this.menuCopy.Products[this.showRollIntoProduct.ProductID],
          modifiers: this.menuCopy.ModifierGroups,
          productId: this.showRollIntoProduct.ProductID,
          initModifiers: this.selectedRollIntoModiefiers
        };
      else return {};
    },
    rollIntoPrice() {
      var result = 0;
      if (this.selectedRollIntoModiefiers.length > 0) {
        this.selectedRollIntoModiefiers.forEach(element => {
          result += element.Price * element.quantity;
        });
        return this.showRollIntoProduct.FixedPriceValue + result;
      } else return 0;
    },
    rollIntoInnerPrice() {
      var result = 0;
      this.RollIntoModifierGroupsStates.filter(p => p.quantity > 0).forEach(
        element => {
          var md = this.modifiers[element.GroupId].Modifiers.find(
            p => p.ID == element.MID
          );
          result += md.Price * element.quantity;
        }
      );
      return this.showRollIntoProduct.FixedPriceValue + result;
    },
    submodifiersPrice() {
      var result = 0;
      this.SubModifierGroupsStates.filter(p => p.quantity > 0).forEach(
        element => {
          var md = this.modifiers[element.GroupId].Modifiers.find(
            p => p.ID == element.MID
          );
          result += (md.Price || 0) * element.quantity;
        }
      );
      return (this.selectedModifierForCustomize.Price || 0) + result;
    },
    initialMainModifiers() {
      var result = [];
      this.ModifierGroupsStates.filter(p => p.quantity > 0).forEach(element => {
        result.push({
          ...this.modifiers[element.GroupId].Modifiers.find(
            p => p.ID == element.MID
          ),
          quantity: element.quantity,
          IsSelected: element.IsSelected
        });
      });
      return result;
    },
    sortedModifierGroupsStates() {
      return this.sortModifierState(this.ModifierGroupsStates);
    }
  },
  created() {
    this.setSkipUpdateTime(true);
  },
  destroyed() {
    this.setSkipUpdateTime(false);
  },
  methods: {
    ...mapMutations(["confirmRollInto", "setSkipUpdateTime"]),
    ...shared.methods,
    sortModifierState(modifierState) {
      var list = modifierState.sort((a, b) => {
        if (!a.GroupDisplayOrder && a.GroupDisplayOrder !== 0) {
          a.GroupDisplayOrder = 1000;
        }
        if (!b.GroupDisplayOrder && b.GroupDisplayOrder !== 0) {
          b.GroupDisplayOrder = 1000;
        }
        var result = a.GroupDisplayOrder - b.GroupDisplayOrder;
        if (!result) {
          result = a.ModifierDisplayOrder - b.ModifierDisplayOrder;
        }
        return result;
      });
      return list;
    },
    ckeckModifierGroupExist() {
      var modifierGroup = [];
      this.product.ModifierGroups.forEach(groupId => {
        var ismodifier = true;
        if (this.modifiers[groupId] && this.modifiers[groupId].Modifiers) {
          if (this.modifiers[groupId].Modifiers.length == 0) ismodifier = false;
          else
            for (var modifier of this.modifiers[groupId].Modifiers) {
              if (modifier.LinkedProductID) {
                ismodifier = false;
                break;
              }
            }
        }
        if (ismodifier) modifierGroup.push(this.modifiers[groupId]);
      });
      return modifierGroup.length > 0;
    },
    addRollInto() {
      var result = [];
      this.RollIntoModifierGroupsStates.filter(p => p.quantity > 0).forEach(
        element => {
          result.push({
            ...this.modifiers[element.GroupId].Modifiers.find(
              p => p.ID == element.MID
            ),
            quantity: element.quantity,
            IsSelected: element.IsSelected
          });
        }
      );
      this.selectedRollIntoModiefiers = result;
      this.toggleRollInto = false;
    },
    cancelRollInto() {
      this.toggleRollInto = false;
      // clear submodifiers
      // this.selectedModifierForCustomize.IsSelected = false;
      // this.selectedModifierForCustomize.quantity = 0;
      var state = this.ModifierGroupsStates.filter(
        p =>
          p.GroupId == this.selectedModifierForCustomize.parent &&
          p.MID == this.selectedModifierForCustomize.ID
      )[0];
      if (state) {
        state.quantity = this.selectedModifierForCustomize.quantity;
        state.IsSelected = this.selectedModifierForCustomize.IsSelected;
      } else {
        state = {
          GroupId: this.selectedModifierForCustomize.parent,
          MID: this.selectedModifierForCustomize.ID,
          quantity: this.selectedModifierForCustomize.quantity,
          IsSelected: this.selectedModifierForCustomize.IsSelected
        };
        this.ModifierGroupsStates.push(state);
      }
      this.$forceUpdate();
    },
    getSubModifierValidation(showError = true) {
      var validate = true;
      if (this.$refs.subModifierRef) {
        validate = this.$refs.subModifierRef.validate(showError);
      }
      return validate;
    },
    addSubmodifiers() {
      if (this.getSubModifierValidation()) {
        if (this.SubModifierGroupsStates.filter(p => p.quantity > 0).length > 0) {
          var result = [];
          this.SubModifierGroupsStates.filter(p => p.quantity > 0).forEach(
            element => {
              result.push(
                JSON.parse(
                  JSON.stringify({
                    ...this.modifiers[element.GroupId].Modifiers.find(
                      p => p.ID == element.MID
                    ),
                    quantity: element.quantity,
                    IsSelected: element.IsSelected
                  })
                )
              );
            }
          );

          this.$set(
            this.selectedModifierForCustomize,
            "selectedSubmodifiers",
            result
          );
        }
        this.cancelSubmodifiers();
      }
    },
    cancelSubmodifiers() {
      this.toggleRollInto = false;
      this.SubModifierGroupsStates.splice(
        0,
        this.SubModifierGroupsStates.length
      );
      this.selectedModifierForCustomize = null;
      this.forceUpdate = !this.forceUpdate;
      this.$forceUpdate();
    }
  }
};
</script>
